import { getDayNumber } from "./getDayNumbers";

export const changeTimeFromMioToNormal = (data) => {
  // Get hours and minutes from the Date object
  const time = new Date(data);
  const hours = time.getHours();
  const minutes = time.getMinutes();

  // Convert the time to the format HH:mm
  const formattedTime = `${String(hours).padStart(2, "0")}:${String(
    minutes
  ).padStart(2, "0")}`;
  // Do something with the formatted time
  return formattedTime;
};
export const convertHtmlTimeToMui = (timeString) => {
  const [hours, minutes] = timeString.split(":").map(Number);

  // Create a new Date object and set the hours and minutes
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);

  // Now, 'date' contains the time in a format suitable for MUI Time Picker
  return date;
};

export const getNextISOString = (inputISOString, dayName, duration) => {
  if (duration) {
    let inputDate = new Date(inputISOString);

    // Calculate the difference in days until next Day (considering Sunday as 0, Monday as 1, ..., Saturday as 6)
    const daysUntilNext = getDayNumber(dayName) - inputDate.getDay() + 7 - 1;

    // If the input date is Today, add 7 days to get the next Monday
    // if (daysUntilNext === 1) {
    //     inputDate.setDate(inputDate.getDate() + 7);
    //     inputDate.setHours(parseInt(inputDate.getHours() + Number(duration)));
    // } else {
    // Set the date to the next Date
    inputDate.setDate(inputDate.getDate() + daysUntilNext);
    inputDate.setHours(parseInt(inputDate.getHours() + Number(duration)));
    // }

    // Format the date to ISO string (in local time zone)
    const nextISOString = inputDate.toISOString();

    return nextISOString;
  } else {
    // Parse the input ISO string to Date object
    const inputDate = new Date(inputISOString);

    // Calculate the difference in days until next Day (considering Sunday as 0, Monday as 1, ..., Saturday as 6)
    const daysUntilNext = getDayNumber(dayName) - inputDate.getDay() + 7 - 1;

    // If the input date is Today, add 7 days to get the next Monday
    // if (daysUntilNext === 1) {
    //     inputDate.setDate(inputDate.getDate() + 7);
    // } else {
    // Set the date to the next Date
    inputDate.setDate(inputDate.getDate() + daysUntilNext);
    // }

    // Format the date to ISO string (in local time zone)
    const nextISOString = inputDate?.toISOString();

    return nextISOString;
  }
};
export const getNextISOStringDynamic = (
  inputISOString,
  dayName,
  dayLength,
  duration
) => {
  if (duration) {
    let inputDate = new Date(inputISOString);

    // Calculate the difference in days until next Day (considering Sunday as 0, Monday as 1, ..., Saturday as 6)
    const daysUntilNext =
      getDayNumber(dayName) - inputDate.getDay() + dayLength - 1;

    // If the input date is Today, add 7 days to get the next Monday
    // if (daysUntilNext === 1) {
    //     inputDate.setDate(inputDate.getDate() +dayLength);
    //     inputDate.setHours(parseInt(inputDate.getHours() + Number(duration)));
    // } else {
    // Set the date to the next Date
    inputDate.setDate(inputDate.getDate() + daysUntilNext);
    inputDate.setHours(parseInt(inputDate.getHours() + Number(duration)));
    // }

    // Format the date to ISO string (in local time zone)
    const nextISOString = inputDate.toISOString();

    return nextISOString;
  } else {
    // Parse the input ISO string to Date object
    const inputDate = new Date(inputISOString);

    // Calculate the difference in days until next Day (considering Sunday as 0, Monday as 1, ..., Saturday as 6)
    const daysUntilNext =
      getDayNumber(dayName) - inputDate.getDay() + dayLength - 1;

    // If the input date is Today, add 7 days to get the next Monday
    // if (daysUntilNext === 1) {
    //     inputDate.setDate(inputDate.getDate() +dayLength);
    // } else {
    // Set the date to the next Date
    inputDate.setDate(inputDate.getDate() + daysUntilNext);
    // }

    // Format the date to ISO string (in local time zone)
    const nextISOString = inputDate?.toISOString();

    return nextISOString;
  }
};
export const getNextISOStringSameWeek = (inputISOString, dayName, duration) => {
  if (duration) {
    let inputDate = new Date(inputISOString);

    // Calculate the difference in days until next Day (considering Sunday as 0, Monday as 1, ..., Saturday as 6)
    const daysUntilNext = getDayNumber(dayName) - inputDate.getDay() - 1;

    // If the input date is Today, add 7 days to get the next Monday
    // if (daysUntilNext === 1) {
    //     inputDate.setDate(inputDate.getDate() + 7);
    //     inputDate.setHours(parseInt(inputDate.getHours() + Number(duration)));
    // } else {
    // Set the date to the next Date
    inputDate.setDate(inputDate.getDate() + daysUntilNext);
    inputDate.setHours(parseInt(inputDate.getHours() + Number(duration)));
    // }

    // Format the date to ISO string (in local time zone)
    const nextISOString = inputDate.toISOString();

    return nextISOString;
  } else {
    // Parse the input ISO string to Date object
    const inputDate = new Date(inputISOString);

    // Calculate the difference in days until next Day (considering Sunday as 0, Monday as 1, ..., Saturday as 6)
    const daysUntilNext = getDayNumber(dayName) - inputDate.getDay() - 1;

    // If the input date is Today, add 7 days to get the next Monday
    // if (daysUntilNext === 1) {
    //     inputDate.setDate(inputDate.getDate() + 7);
    // } else {
    // Set the date to the next Date
    inputDate.setDate(inputDate.getDate() + daysUntilNext);
    // }

    // Format the date to ISO string (in local time zone)
    const nextISOString = inputDate?.toISOString();

    return nextISOString;
  }
};

export const isBeforeApril1st2024 = () => {
  // Get today's date
  var today = new Date();

  // April 1st, 2024
  var aprilFirst2024 = new Date('2024-04-01');

  // Compare dates
  if (today < aprilFirst2024) {
    return true; // Today is before April 1st, 2024
  } else {
    return false; // Today is on or after April 1st, 2024
  }
}
